import { fetcher } from '../../../../scripts/utils/fetch.js';
import Urls from '../urls.js';

export default class SessionContactInfoModel {
	constructor (attributes = {}) {
		this.attributes = attributes;
	}
	url () {
		return Urls.Api.contact_info;
	}
	save() {
		const url = this.url();

		return fetcher(url, {
			method: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(this.attributes)
		});
	};
}